import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b1abd2b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-12 py-3 py-sm-4 bg-custom-gradient" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container flex-centered py-md-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "register-warranty-text my-3 text-center flex-wrap" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "text-decoration-none",
      target: "_blank",
      href: "https://www.tevo.co.za/warranty"
    }, [
      /*#__PURE__*/_createElementVNode("button", { class: "btn btn-black px-5 py-1 py-2 text-uppercase" }, "Click here to register your warranty")
    ])
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}